

import Vue from 'vue'
import * as uiv from 'uiv'
// import locale from 'uiv/src/locale/lang/pt-BR'

// Vue.use(uiv, { locale })
Vue.use(uiv)



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/uiv.js